import React from 'react';
import classnames from 'classnames';
import { IconAppForegroundFill, IconSearchFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import { Link } from '@saucelabs/ds-link';

import Styles from './EmptyState.styles';

interface EmptyStateProps {
  searchTermExists: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ searchTermExists }) => (
  <span className={classnames(Styles['no-mobile-apps'], 'flex flex-col justify-center items-center normal-case')}>
    {searchTermExists ? <IconSearchFill className="fill-current text-gray-400" /> : <IconAppForegroundFill className="fill-current text-gray-400" />}
    <Typography
      className="text-high-emphasis"
      variant="heading-4"
    >
      {searchTermExists ? 'We found no results.' : 'You don\'t have any mobile apps stored.'}
    </Typography>
    <Typography
      className="font-normal text-medium-emphasis"
      variant="body-large"
    >
      {searchTermExists ? 'Try updating your search criteria.' : (
        <>
          <span>Check your data center or </span>
          <Link
            inline
            size="large"
            to="/app-management"
          >
            upload an app now
          </Link>
          .
        </>
      )}
    </Typography>
  </span>
);

export default EmptyState;
